import React from "react";
import Fixed from "./Fixed";
import Footer1 from "./Footer1";

const TermsAndConditions = () => {
  return (
    <div className="bg-gray-100 min-h-screen flex flex-col">
      <Fixed />
      
      <div className="flex-grow flex justify-center items-center p-6 pt-32">
        <div className="max-w-4xl bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-6 text-center">Terms & Conditions</h1>
          <p className="text-gray-600 mb-6 text-center">
            Welcome to <strong>JCS Global</strong>. These terms and conditions outline the rules and regulations for the use of our website.
          </p>

          <div className="border-l-4 border-blue-500 pl-4 mb-6">
            <p className="text-gray-700 font-medium">
              By accessing this website, we assume you accept these terms and conditions. If you do not agree with any part 
              of these terms, please refrain from using our website.
            </p>
          </div>

          {/* Section 1 */}
          <h2 className="text-2xl font-semibold text-gray-700 mt-6">1. License to Use</h2>
          <p className="text-gray-600 mb-4">
            Unless otherwise stated, JCS Global and/or its licensors own the intellectual property rights for all material 
            on this website. You may access this for personal use, subject to the restrictions set in these terms.
          </p>

          {/* Section 2 */}
          <div className="flex justify-center">
  <div className="w-full max-w-2xl">
    <h2 className="text-2xl font-semibold text-gray-700 mt-6 text-center">2. Restrictions</h2>
    <p className="text-gray-600 mb-4 text-center">You are prohibited from:</p>
    <ul className="pl-6 text-gray-600 mb-4 space-y-3">
      <li className="flex items-center justify-center">
        <span className="text-red-500 mr-2">❌</span> Republishing material from JCS Global
      </li>
      <li className="flex items-center justify-center">
        <span className="text-red-500 mr-2">❌</span> Selling, renting, or sub-licensing material
      </li>
      <li className="flex items-center justify-center">
        <span className="text-red-500 mr-2">❌</span> Reproducing, duplicating, or copying material
      </li>
      <li className="flex items-center justify-center">
        <span className="text-red-500 mr-2">❌</span> Using the website in any way that is damaging
      </li>
      <li className="flex items-center justify-center">
        <span className="text-red-500 mr-2">❌</span> Engaging in data mining, data harvesting, or any similar activity
      </li>
    </ul>
  </div>
</div>




          {/* Section 3 */}
          <h2 className="text-2xl font-semibold text-gray-700 mt-6">3. User Responsibilities</h2>
          <p className="text-gray-600 mb-4">
            By using this website, you agree to use it only for lawful purposes and not to violate any applicable laws 
            or regulations. Any misuse may lead to legal action.
          </p>

          {/* Section 4 */}
          <h2 className="text-2xl font-semibold text-gray-700 mt-6">4. Limitation of Liability</h2>
          <p className="text-gray-600 mb-4">
            JCS Global, its directors, employees, and affiliates will not be liable for any damages arising out of or in 
            connection with your use of this website. This includes direct, indirect, or consequential damages.
          </p>

          {/* Section 5 */}
          <h2 className="text-2xl font-semibold text-gray-700 mt-6">5. Changes to Terms</h2>
          <p className="text-gray-600 mb-4">
            JCS Global reserves the right to revise these terms at any time. By continuing to use the website, you agree to 
            be bound by the updated terms.
          </p>

          {/* Contact Section */}
          <div className="mt-6 text-center">
            <p className="text-gray-500 text-sm">
              <strong>Last updated:</strong> February 2025  
              <br />
              For any inquiries, contact us at  
              <a href="mailto:tech.support@jcsglobal.in" className="text-blue-600 hover:underline ml-1">
                tech.support@jcsglobal.in
              </a>
            </p>
          </div>
        </div>
      </div>

      <Footer1 />
    </div>
  );
};

export default TermsAndConditions;
